import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import IndustriesSection from '../components/IndustriesSection';
import PartnershipSection from '../components/PartnershipSection';
import PilotPhaseSection from '../components/PilotPhaseSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <IndustriesSection />
      <PartnershipSection />
      <PilotPhaseSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default LandingPage;
